export default {"src":"/_next/static/media/BSY.737ec33e.svg","height":18,"width":18};